import { createContext } from "react";

const EstadosCivilesContext = createContext();

export default EstadosCivilesContext;
